
import {Component, Mixins} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {TasinirHacizTalep} from "@/interface/IUyapTalep";

@Component({
  components: {}
})
export default class TasinirHacizTalepEvrakForm extends Mixins(ObjectInputMixin) {
  localValue!: TasinirHacizTalep;
}
